<template>
  <div class="deposit-container">
    <div class="deposit-card">
      <!-- 币种选择 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">{{ $t('_cbsq._bz') }}</span>
        </div>
        <div class="currency-grid">
          <div
            v-for="(vo, i) in currencyList"
            :key="i"
            class="currency-item"
            :class="{ active: currencyIndex === i }"
            @click="onCurrencyChange(i)"
          >
            <img :src="require('../../static/img_icon/' + vo.text.toLowerCase() + '.png')" class="currency-icon" />
            <span class="currency-name">{{ vo.text }}</span>
          </div>
        </div>
      </div>

      <!-- 网络选择 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">{{ $t('_cbsq._wl') }}</span>
        </div>
        <div class="network-grid">
          <div
            v-for="(vo, i) in protocolList"
            :key="i"
            class="network-item"
            :class="{ active: protocolIndex === i }"
            @click="onProtocolClick(i)"
          >
            {{ vo.network }}
          </div>
        </div>
      </div>

      <!-- 二维码 -->
      <div class="section qr-section">
        <div class="qr-header">
          <span class="qr-label">{{ $t('_cbsq._erwm') }}</span>
          <span class="qr-network">{{ current.name }}-{{ current.network }}</span>
        </div>
        <div class="qr-wrapper">
          <div class="qr-box">
            <img :src="current.qr_code" class="qr-image" />
            <div class="qr-address">{{ current.address }}</div>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button class="btn-copy" @click="onCopy(current.address)">
          <i class="fas fa-copy"></i>
          {{ $t('_cbsq._fzdz') }}
        </button>
        <button class="btn-back" @click="onBack('wallet')">
          <i class="fas fa-arrow-left"></i>
          {{ $t('_sp._fanh') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositVue',
  data() {
    return {
      currencyList: [],
      currencyIndex: 0,
      protocolList: [],
      protocolIndex: 0,
      current: {}
    }
  },
  created() {
    this.getCurrencyList()
  },
  methods: {
    onBack(name) {
      this.$router.push({ name: name })
    },

    getCurrencyList() {
      this.$api.chain.getCurrencyList().then((res) => {
        this.currencyList = res.data || []
        if (this.currencyList.length > 0) {
          this.onCurrencyChange(0)
        }
      })
    },

    onCurrencyChange(i) {
      this.currencyIndex = i
      this.protocolList = this.currencyList[i]?.protocol || []
      this.onProtocolClick(0)
    },

    onProtocolClick(i) {
      this.protocolIndex = i
      this.current = this.protocolList[i] || {}
    },

    onCopy(token) {
      if (!token) {
        this.$message.warning('暂无地址可复制')
        return
      }
      this.$copyText(token)
        .then(() => {
          this.$message.success('复制成功！')
        })
        .catch(() => {
          this.$message.error('复制失败，请手动复制')
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   充值页面 - 深灰主题
   ============================================================ */

.deposit-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

.deposit-card {
  max-width: 800px;
  margin: 0 auto;
  background: #1a1f26;
  border-radius: 16px;
  border: 1px solid #2a3038;
  padding: 28px 32px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* ============================================================
   区块
   ============================================================ */
.section {
  margin-bottom: 24px;
}

.section:last-of-type {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #e8edf2;
}

/* ============================================================
   币种选择
   ============================================================ */
.currency-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

.currency-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 10px;
  background: #0f1419;
  border-radius: 12px;
  border: 2px solid #2a3038;
  cursor: pointer;
  transition: all 0.3s ease;
}

.currency-item:hover {
  border-color: #3a4652;
  transform: translateY(-2px);
}

.currency-item.active {
  border-color: #ffb300;
  background: rgba(255, 179, 0, 0.06);
  box-shadow: 0 0 20px rgba(255, 179, 0, 0.04);
}

.currency-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.currency-name {
  font-size: 14px;
  font-weight: 600;
  color: #8a949f;
}

.currency-item.active .currency-name {
  color: #ffb300;
}

/* ============================================================
   网络选择
   ============================================================ */
.network-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.network-item {
  padding: 8px 24px;
  background: #0f1419;
  border-radius: 20px;
  border: 1px solid #2a3038;
  color: #8a949f;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.network-item:hover {
  border-color: #3a4652;
  color: #e8edf2;
}

.network-item.active {
  border-color: #ffb300;
  background: rgba(255, 179, 0, 0.06);
  color: #ffb300;
}

/* ============================================================
   二维码
   ============================================================ */
.qr-section {
  margin-bottom: 20px;
}

.qr-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.qr-label {
  font-size: 16px;
  font-weight: 600;
  color: #e8edf2;
}

.qr-network {
  font-size: 14px;
  color: #6a7a8a;
  background: #0f1419;
  padding: 3px 14px;
  border-radius: 12px;
}

.qr-wrapper {
  display: flex;
  justify-content: center;
}

.qr-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  background: #0f1419;
  border-radius: 12px;
  padding: 20px 20px 16px;
  border: 1px solid #2a3038;
}

.qr-image {
  width: 280px;
  height: 280px;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.qr-address {
  font-size: 14px;
  color: #8a949f;
  font-family: 'Courier New', monospace;
  word-break: break-all;
  text-align: center;
  max-width: 280px;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

/* ============================================================
   操作按钮
   ============================================================ */
.action-buttons {
  display: flex;
  gap: 12px;
}

.btn-copy {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-copy:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

.btn-back {
  flex: 1;
  padding: 12px 20px;
  border: 1px solid #2a3038;
  border-radius: 10px;
  background: transparent;
  color: #8a949f;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: #3a4652;
  color: #e8edf2;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 640px) {
  .deposit-card {
    padding: 20px 18px 18px;
    border-radius: 12px;
  }

  .currency-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .currency-item {
    padding: 10px 6px;
  }

  .currency-icon {
    width: 32px;
    height: 32px;
  }

  .currency-name {
    font-size: 12px;
  }

  .network-item {
    padding: 6px 16px;
    font-size: 13px;
  }

  .qr-image {
    width: 200px;
    height: 200px;
  }

  .qr-address {
    font-size: 12px;
    max-width: 200px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-copy,
  .btn-back {
    padding: 10px 16px;
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .deposit-card {
    padding: 16px 12px 14px;
  }

  .currency-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .currency-item {
    padding: 10px 8px;
  }

  .currency-icon {
    width: 28px;
    height: 28px;
  }

  .qr-image {
    width: 160px;
    height: 160px;
  }

  .qr-address {
    font-size: 11px;
    max-width: 160px;
  }

  .section-title {
    font-size: 14px;
  }

  .btn-copy,
  .btn-back {
    font-size: 13px;
    padding: 8px 14px;
  }
}
</style>